<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <div class="d-flex justify-content-between align-items-center">
    <h2>Res Master Report</h2>
    <app-import-export
      importEnabled="false"
      [dataRetrived]="rowData"
      (exportDataSelected)="exportSelected($event)"
      [importDisabled]="true">
    </app-import-export>
  </div>

  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
      [showReservationStatus]=true [showReportType]=true [showResMasReportName]=true [showStartDate]=true [showEndDate]=true [showSaleDateStart]=true
      [showSaleDateEnd]=true [showCancelDateStart]=true [showCancelDateEnd]=true [defaultStartDate]="defaultStartDate" [showSaleYear]=false [displayRecordsOnPageLoad]="false"
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [startDateLabel]="'Check-In Date'" [endDateLabel]="'Check-Out Date'"
      [showBlankStartAndEndDate]=true [showReferralSources]=false [showResTypes]=false
      [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="loadReport($event)">
    </app-search-template>
  }
  <!-- <button pButton type="button" label="View Report"
  icon="pi pi-table"
(click)="loadReport()"></button> -->
<br><br>

<div class="ag-theme-balham grid-container my-grid">
  <ag-grid-angular
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>

</div>